<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Schedule Requests",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Doctor Schedule Requests",
            items: [
               {
                  text: "Schedule Requests",
                  active: true,
               },                   
            ],

            listing_length: 10,
            keyword: '',
            approve: {
               service_charge: '',
               commission: ''
            },
            requests:[],
         };
      },
      mounted() {
         this.clearLocalStorage();

      },
      created() {
         this.fetchRequests();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },
        fetchRequests(page_url = null) {
            this.getToken();
            let url = "api/admin/doctors/schedule_requests?keyword=" + this.keyword + "&limit=" + this.listing_length;

            page_url = page_url || url;

            if(localStorage.back_url) {
            page_url = localStorage.back_url;  
            localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;

            this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                var responseData = res.data.data;
                console.log(responseData);
                this.requests = responseData.schedule_requests.data;
                
                this.pagination = responseData.schedule_requests.links;
                this.from = responseData.schedule_requests.from;
                this.to = responseData.schedule_requests.to;
                this.total = responseData.schedule_requests.total;
            
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                        } else {
                        this.$swal("", error.response.data.message, "error");
                        }                        
                        
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                } else {
                    this.$swal("", "Something went wrong", "error");
                }
            })
            .finally(() => (this.loading = false));
        }, 

        getToken() {
            if (localStorage.getItem('medicino_admin')) {
            var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
            if(medicino_admin.token) {
                this.token = medicino_admin.token;
            } else {
                this.$swal("", "Failed to fetch token, please login again", "error");
                this.$router.push({ name: "login" });
            }
            
            } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
            }
        }, 
        approveSchedule(schedule_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to approve this schedule request?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };

                  let formData = new FormData();
                  formData.append("schedule_id", schedule_id); 
                       
                  let url = "api/admin/doctors/schedule_request_approve";
                  this.$axios
                  .post(url, formData, config)
                  .then((response) => {
                     if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                     } else {
                        this.$swal("", response.data.message, "error");
                     }
                     this.fetchRequests(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           this.$swal("", error.response.data.message, "error");
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
        },
        rejectSchedule(schedule_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to reject this schedule request?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };

                  let formData = new FormData();
                  formData.append("schedule_id", schedule_id); 
                       
                  let url = "api/admin/doctors/schedule_request_reject";
                  this.$axios
                  .post(url, formData, config)
                  .then((response) => {
                     if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                     } else {
                        this.$swal("", response.data.message, "error");
                     }
                     this.fetchRequests(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
        },
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },   
      }
   }
</script>
    
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <!-- <h4 class="card-title"></h4>
                        <p class="card-title-desc"></p> -->

                    

                        <!----- Listing length and search starts ----->
                        <div class="row mb-3">
                            <div class="col-sm-12 col-md-6">
                                <div class="listing-length" >
                                <label
                                    >Show
                                    <select class="form-control" v-model="listing_length" @change="fetchRequests()">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                    </select>
                                    entries
                                </label>
                                </div>                        
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div class="listing-filter">
                                <label>
                                    <input type="text" class="form-control" placeholder="Search" v-model="keyword"  @keyup="fetchRequests()"/>
                                </label>
                                </div>                                      
                                
                            </div>
                        </div>
                        <!----- Listing length and search ends ----->

                        <!---- listing table starts -------->
                        <div class="table-responsive">
                            <table class="table table-bordered mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th>Name</th>  
                                        <th>Contact</th>
                                        <th>Specializations</th>    
                                        <th>Added By</th>                         
                                        <th>Created On</th>                              
                                        <th>Options</th>
                                    </tr>
                                </thead>
                                <tbody v-if="Boolean(requests.length)">
                                    <tr v-for="(request) in requests" :key="request.id">
                                        <td><span v-if="request.prefix == 1">Dr.</span><span v-else-if="request.prefix == 2">Mr.</span><span v-else-if="request.prefix == 3">Ms.</span>{{request.doctor_name}}</td>                      
                                        <td>
                                            {{request.country_code}} {{request.mobile}}<br>
                                            {{request.email}}<br>
                                        </td>

                                        <td>
                                            <span v-for="specializatio in request.doctor.specialization" :key="specializatio.id">
                                                {{specializatio.specialization}}<br>
                                            </span>
                                        </td>
                                        
                                        <td>
                                            <span v-if="request.added_by==1">Admin</span>
                                            <span v-else-if="request.added_by==4">{{ request.added_user_details.name }}</span>
                                            <span v-else>Self</span>
                                        </td>

                                        <td>{{request.created_at | formatDateTime}}</td>
                                        
                                        <td>

                                            <router-link :to="{ name: 'doctors.schedule.requests.details', params: {id: request.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>
                                            <b-button  variant="success" class="me-2 mb-2 btn-sm" @click="approveSchedule(request.id)">Approve</b-button>

                                            <b-button  variant="danger" class="me-2 mb-2 btn-sm" @click="rejectSchedule(request.id)">Reject</b-button>

                                            
                                        </td>
                                    </tr>
                        
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="6" class="text-center">No requests found</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!---- listing table ends -------->

                        <!----pagination starts --->     
                        <caption v-if="Boolean(requests.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                        <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                            <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                                <a href="#" class="page-link" @click.prevent="fetchRequests(page.url + '&limit='+ listing_length + '&keyword=' + keyword )">
                                <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                                <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                                <span v-else>{{page.label}}</span>                          
                                </a>
                            </li>
                        </ul>
                        <!----pagination ends --->

                    </div>
                </div>
            </div>
        </div>

      <!---- modal starts ---->
      <b-modal ref="approve-modal" id="approve-modal" title="Approve Doctor" hide-footer>
         <b-form>
            <b-row>  
               <b-col lg="12" class="form-group">
                  <label class="control-label">Convenience Fee<span class="text-danger">*</span></label>
                  <b-form-input type="number" min="0" v-model="approve.service_charge"></b-form-input>
               </b-col>   
               <b-col lg="12" class="form-group">
                  <label class="control-label">Platform Fee<span class="text-danger">*</span></label>
                  <b-form-input type="number" min="0" v-model="approve.commision"></b-form-input>
               </b-col>              
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Approve</b-button>
                  <b-button class="" variant="light" @click="hideModal('approve-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
